/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventScreenNewDesktop_query = {
    readonly " $fragmentRefs": FragmentRefs<"SponsorsSection_query" | "EventScreenAttendCard_query" | "EventScreenJoin_query">;
    readonly " $refType": "EventScreenNewDesktop_query";
};
export type EventScreenNewDesktop_query$data = EventScreenNewDesktop_query;
export type EventScreenNewDesktop_query$key = {
    readonly " $data"?: EventScreenNewDesktop_query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventScreenNewDesktop_query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewDesktop_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SponsorsSection_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenAttendCard_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenJoin_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '4cb3a460b82bb24f47f1ede58f3efce2';
export default node;
